import { AfterViewChecked, ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { Event, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subscription } from 'rxjs';
import { LoaderService } from './core/http/loader.service';
import { AuthService } from './core/services/auth/auth.service';
import { ServerNotiModel } from './core/view-models/server-notification';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ServerNotificationService } from './core/services/server-notification/server-notification.service';
import { ModalNotificationComponent } from './shared/components/modal-notification/modal-notification.component';
import { UserProfileModel } from './core/models/users/user-profile.model';
import { ManualService } from './core/services/manual/manual.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy, AfterViewChecked {
  
  isShow:boolean = false
  topPosToStartShowing = 200;
  showLoader = false;
  displayLoader = false;
  loaderSubscription: Subscription = new Subscription;
  noti: ServerNotiModel = new ServerNotiModel
  user$!: Observable<UserProfileModel>;
  constructor(
    private router: Router,
    private cdRef: ChangeDetectorRef,
    private loaderService: LoaderService,
    private translate: TranslateService,
    private authService: AuthService,
    private dateAdapter:DateAdapter<Date>,
    private modalService: NgbModal,
    private serverNotificationService: ServerNotificationService,
    private manualService:ManualService,
  ) {
    this.dateAdapter.setLocale('en-us');
    translate.setDefaultLang('th');
    // this.router.events.subscribe((evt) => {
    //   if (!(evt instanceof NavigationEnd)) {
    //     return;
    //   }
    //   window.scrollTo(0, 0)
    // });
    
  }



  ngOnInit(): void {
    

    this.loaderSubscription = this.loaderService.loaderCounter.subscribe((counter: number) => {
      this.displayLoader = counter !== 0;
    });
    this.router.events.subscribe((event: Event) => {
      this.handleRouteChange(event);
    });

    this.loadPermissions();
    this.checkScroll()
    this.checkServer()
  }

  async loadPermissions() {
    await this.authService.loadPermissions();
  }

  ngOnDestroy(): void {
    this.loaderSubscription.unsubscribe();
  }

  ngAfterViewChecked(): void {
    const show = this.displayLoader;
    if (show !== this.showLoader) { // check if it change, tell CD update view
      this.showLoader = show;
      this.cdRef.detectChanges();
    }
  }

  handleRouteChange(event: Event) {
    switch (true) {
      case event instanceof NavigationStart:
        this.loaderService.enable();
        break;
      case event instanceof NavigationEnd:
      case event instanceof NavigationCancel:
      case event instanceof NavigationError: {
        this.loaderService.disable();
        break;
      }
      default: {
        break;
      }
    }
  }

  @HostListener("window:scroll")checkScroll() {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      
    if (scrollPosition >= this.topPosToStartShowing) {
      this.isShow = true;
    } else {
      this.isShow = false;
    }
  }

  gotoTop() {
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'auto' 
    });
  }

  async checkServer() {
    const result = await this.serverNotificationService.getServerNotification()
    console.log('result',result)
    if(result){
      this.noti = result
      if(this.noti.active){
        this.notiServer()
      }
    }
  }

  notiServer() {
    if (this.noti.notiFile.extension == 'jpg' || this.noti.notiFile.extension == 'jpeg') {
      const modalRef = this.modalService.open(ModalNotificationComponent, {
        backdrop: 'static',
        keyboard: false,
        centered: true,
        size: 'xl'
      });
      //modalRef.componentInstance.name = file.foundationName
      modalRef.componentInstance.noti = this.noti
      modalRef.componentInstance.callbackUpdate.subscribe(async (result: any) => {

      })
    }
  }

}
